<template>
  <Content id="tasks">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="任务名称" :label-width="70"><el-input v-model="search.name" :maxlength="100" :clearable="true" style="min-width: 300px;"/></FormItem></Col>
          <Col>
            <FormItem  label="学校" prop="schoolId">
              <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" @change="changeSchool" style="min-width: 300px;">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleShoolChange(item)" style="min-width: 300px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="体检日期" :label-width="75">
              <DatePicker style="width:112px;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd"
                          v-model="search.startPhysicalDate" @on-change="changestart"/>
              <DatePicker style="width:112px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd"
                          v-model="search.endPhysicalDate" @on-change="changeend"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="报名日期" :label-width="75">
              <DatePicker style="width:112px;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd"
                          v-model="search.signUpStartDate" @on-change="changeSignUpStart"/>
              <DatePicker style="width:112px;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd"
                          v-model="search.signUpEndDate" @on-change="changeSignUpEnd"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="来源">
              <Select v-model="search.sources" style="width:100%;min-width: 90px;"  :clearable="true">
                <Option v-for="item in enums.sourcesList" :value="item.value" v-bind:key="item.value" style="width:100%;">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width:100%;"  :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value" style="width:100%;">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-top: 5px; margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed="left" align="center" prop="name" label="任务名称" min-width="350"/>
      <el-table-column align="center" prop="physicalDate" label="预计体检日期" show-overflow-tooltip  min-width="110"/>
      <el-table-column align="center" prop="schoolName" label="体检学校" min-width="200"/>
      <el-table-column align="center" prop="signUpStartDate" label="报名开始日期" min-width="110"/>
      <el-table-column align="center" prop="signUpEndDate" label="报名结束日期" min-width="110"/>
      <el-table-column align="center" prop="signUpNum" label="已报名人数" min-width="90"/>
      <el-table-column align="center" prop="completedNum" label="已完成人数" min-width="90"/>
      <el-table-column align="center" prop="source" label="来源" min-width="80">
        <template slot-scope="{row}">{{  enums.sourcesList.filter(u => u.value === row.sources)[0].label }}</template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="最后操作时间" min-width="160"/>
      <el-table-column align="center" prop="status" label="状态"  min-width="50">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="260">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="update(row)" v-if="row.signUpNum == 0">编辑</el-button>
          <el-button type="text" size="medium" @click="qrCode(row)">二维码</el-button>
          <el-button type="text" size="medium" @click="download(row)">下载二维码</el-button>
          <el-button type="text" size="medium" @click="reportGen(row)">报告生成</el-button>
          <el-button type="text" size="medium" @click="detail(row)">详情</el-button>
<!--          <el-button type="text" size="small" @click="lisPush(row)" v-if="row.completedNum&&row.completedNum>0">推送</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <!--编辑窗口-->
    <Modal v-model="editWindow" width="70%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <TaskEdit ref="edit" :style="{'overflow-y': 'auto'}" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button @click="editWindow = false" v-if="showButton">取消</Button>
        <Button type="primary" @click="submit" v-if="showButton">确认</Button>
      </div>
    </Modal>

    <!--二维码窗口-->
    <TaskQRCode ref="QRCode"/>

    <!--报告窗口-->
    <Modal v-model="reportWindow" width="50%" :title="reportWindowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <ReportGen ref="report"  :style="{'max-height':maxHeight, 'overflow-y':'auto'}" @on-submit="handleReport"/>

      <div slot="footer">
        <Button @click="reportWindow = false">取消</Button>
        <Button type="primary" @click="report">确认</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {_page, _lisPush, _updateStatus, _downloadQrCode} from "@/services/task/task";
import TaskEdit from "./TaskEdit";
import ReportGen from "./ReportGen.vue";
import TaskQRCode from "./TaskQRCode.vue";
import {mixins} from "@/mixins/index.js";
import {enums} from "@/services/enums";
import dayjs from "dayjs";

export default {
  name: "Task",
  mixins: [mixins],
  components: {
    TaskEdit, ReportGen, TaskQRCode
  },
  computed: {

  },
  data() {
    return {
      maxHeight: 0,
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        name: "",
        gender: "",
        idCard: "",
        schoolId: "",
        gradeId: "",
        classesId: "",
        status: 1,
        // startPhysicalDate:dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
        // endPhysicalDate:dayjs().format('YYYY-MM-DD'),
        // signUpStartDate:dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
        // signUpEndDate:dayjs().format('YYYY-MM-DD')
        startPhysicalDate:"",
        endPhysicalDate:"",
        signUpStartDate:"",
        signUpEndDate:"",
      },
      enums: enums,
      showButton: true,
      reportWindow: false,
      reportWindowTitle: "批量生成体检报告",
      editWindow: false,
      windowTitle: "新增",
      schoolsList: [],
      gradeList: [],
      classesList: [],
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  async mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      await this.applySchoolsList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 305}px`;
      this.maxHeight = `${height - 305}px`;
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode === 1 && res.data) {
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        }
      }).catch(() => {});
    },
    handleModal(windowTitle, row) {
      this.windowTitle = windowTitle;
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.showButton = true;
      this.handleModal("新增任务");
    },
    update(row){
      this.showButton = true;
      this.handleModal("编辑任务", row);
    },
    detail(row) {
      this.showButton = false;
      this.handleModal("详情", row);
    },
    qrCode(row) {
      this.$refs["QRCode"].handleModal(row.id);
    },
    download(row){
      _downloadQrCode({taskId:row.id}).then(res => {
        if (res && res.errcode && res.errcode === 1){

        } else{
          this.$message.error(res.errmsg)
        }
      })
    },
    reportGen(row) {
      this.reportWindowTitle = "批量生成体检报告 (体检任务:" + row.name + ")";
      this.reportWindow = true;
      this.$refs["report"].handleModal(row.id);
    },
    lisPush(row) {
      if (row && row.id) {
        this.$confirm('确认要推送该任务下已完成体检的' + (row.lisPush == 1 ? '待推送' : (row.lisPush == 2 ? '已推送' : '推送失败')) + '检验单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          _lisPush({taskId: row.id}).then(res => {
            if (res.errcode === 1) {
              this.$message.success('推送完成');
              this.handleDataList();
            } else {
              this.$message.error(res.errmsg);
            }
          }).catch(() => {});
        }).catch(() => {
        });
      }
    },
    submit() {
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if (!result) {
        this.editWindow = result;
        this.handleDataList();
      }
    },
    // print(){
    //   this.$nextTick(()=>{
    //     document.getElementById('print').click();
    //   })
    // },
    // handlePrint(result) {
    //   if(!result){
    //     this.QRCodeWindow = result;
    //   }
    // },
    report() {
      this.$refs['report'].handleSubmit();
    },
    handleReport(result) {
      if (!result) {
        this.reportWindow = result;
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changestart(e) {
      this.search.startPhysicalDate = e
    },
    changeend(e) {
      this.search.endPhysicalDate = e
    },
    changeSignUpStart(e) {
      this.search.signUpStartDate = e
    },
    changeSignUpEnd(e) {
      this.search.signUpEndDate = e
    },
  }
};
</script>

<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
.el-table{border: 0px solid #ccc;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-table .el-table__cell {padding: 11px 0;}

</style>
